const appearanceSchemaMapper = (restSchema) => ({
  status: 1,
  entityBundle: "appearance",
  label: restSchema.title,
  id: restSchema.nid,
  title: restSchema.title,
  created: restSchema.created,
  path: {
    alias: restSchema.url,
  },
  uri: {
    path: restSchema.url,
  },
  fieldWeekday: restSchema.weekday,
  fieldPlanned: restSchema.planned,
  fieldFake: restSchema.fake,
  fieldVenueLocation: {
    label: restSchema.venue_location_name,
    id: restSchema.venue_location_id,
    url: {
      path: restSchema.venue_location_url,
    },
    fieldAccesibility: restSchema.venue_accessibility_frontend_id
      ? Array.isArray(restSchema.venue_accessibility_frontend_id)
        ? restSchema.venue_accessibility_frontend_id.map((id) => ({
            fieldTaxonomyFrontendId: id,
          }))
        : [
            {
              fieldTaxonomyFrontendId: restSchema.venue_accessibility_frontend_id,
            },
          ]
      : [],
  },
  fieldEdition: {
    id: restSchema.edition_id,
    label: restSchema.edition_label,
  },
  fieldHappening: restSchema.happening_title
    ? {
        entityBundle: restSchema.happening_bundle,
        label: restSchema.happening_title,
        id: restSchema.happening_nid,
        title: restSchema.happening_title,
        created: restSchema.happening_created,
        path: {
          alias: restSchema.happening_url,
        },
        url: {
          path: restSchema.happening_url,
        },
        fieldTicket: {
          uri: {
            path: restSchema.happening_ticket,
          },
        },
        fieldTags: null,
        fieldSubline: restSchema.happening_subline,
        fieldInvitationOnly: restSchema.happening_invitation_only,
        fieldEventType: {
          name: restSchema.happening_event_type,
        },
        fieldParticipantCategory: {
          name: restSchema.happening_participant_category,
        },
        fieldSessionGenre: {
          name: restSchema.happening_session_genre,
        },
        fieldSessionCategory: {
          name: restSchema.happening_session_category,
        },
        fieldFormat: {
          name: restSchema.happening_format,
        },
        fieldSpokenLanguage: restSchema.happening_spoken_language
          ? Array.isArray(restSchema.happening_spoken_language)
            ? restSchema.happening_spoken_language.map((name, idx) => ({
                name,
                fieldLanguageId: restSchema.happening_spoken_language_id?.[idx],
              }))
            : [
                {
                  name: restSchema.happening_spoken_language,
                  fieldLanguageId: restSchema.happening_spoken_language_id,
                },
              ]
          : null,

        fieldText: restSchema.happening_text,
        fieldSponsoredCroppedImage:
          restSchema.happening_sponsored_cropped_image === "1",
        fieldImage: restSchema.happening_image_url
          ? {
              fieldCredits: restSchema.happening_image_credits,
              fieldMediaImage: {
                alt: restSchema.happening_image_alt,
                title: restSchema.happening_image_title,
                style: {
                  url: restSchema.happening_image_url,
                },
              },
            }
          : null,
      }
    : null,
  /* fieldSpokenLanguageRawField {
    list {
    targetId
      entity {
        ... on TaxonomyTermSpokenLanguage {
        name;
        fieldLanguageId;
      }
    }
  }
}
  fieldAppearances {
    ... on NodeAppearance {
    status
      fieldVenueLocation {
        ... on OsLocation {
        label
          url {
          path;
        }
      }
    }
    fieldPlanned;
    fieldFake
      fieldDateRawField {
        first {
        value;
        endValue;
        duration;
        rrule;
        rruleIndex;
        timezone;
      }
    }
  } */
  /* {
      ...TeaserEvent
      ...TeaserAct;
  } */
  fieldMainPresenter: Array.isArray(restSchema.main_presenter)
    ? restSchema.main_presenter.join(", ")
    : restSchema.main_presenter,
  fieldDateRawField: {
    first: {
      value: restSchema.date_start,
      endValue: restSchema.date_end,
      duration: restSchema.date_duration,
      rrule: restSchema.date_rrule,
      rruleIndex: restSchema.date_rruleIndex,
      timezone: restSchema.date_timezone,
    },
  },
});

export default appearanceSchemaMapper;
